module.exports = __webpack_public_path__ + "static/media/chipa_dulce.87848050.png";